module.exports = __webpack_public_path__ + "img/H2.8bd38ad3.jpg";